const TextCell = (accessor, header) => ({ Header: header || accessor, accessor: accessor, })

const SearchableTextCell = (accessor, header) => ({ ...TextCell(accessor, header), canSearch: true })

const HiddenSearchableText = (accessor, header) => ({ ...SearchableTextCell(accessor, header), visible: false })

const CustomCell = (header, component) => ({ Header: header, Cell: ({ row: { original } }) => component(original) })

const CheckboxColumn = (HeaderCell , RowCell) => ({
    id: "select",
     Header: ({ getToggleAllPageRowsSelectedProps }) => 
      HeaderCell({ getToggleAllPageRowsSelectedProps }),
    Cell: ({ row }) => RowCell({ row })
})


export const ColumnsGenerator = {
    TextCell,
    SearchableTextCell,
    HiddenSearchableText,
    CustomCell,
    CheckboxColumn
}